import { QueryClient } from "@tanstack/react-query";
import { syncQueryCacheAcrossTabs } from "@lib/crossTabQuerySync";
import { shareQueryData } from "@lib/shareQueryData";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 5,
            structuralSharing: shareQueryData,
        },
    },
});

syncQueryCacheAcrossTabs({
    queryClient,
    channelName: `kick-app-${__VITE_BUILD_ID__}`,
});

export function getAddressQueryKey(entityId: number) {
    return ["address", entityId];
}
export function getPayrollQueryKey(entityId: number) {
    return ["entityPayrolls", entityId];
}

export const locksQueryKey = "locks";
export function getLockQueryKey(entityId?: number | null) {
    return [locksQueryKey, entityId];
}
export function getLocksQueryKey(entityIds: number[]) {
    return [locksQueryKey, entityIds];
}

export const financialConnectionsQueryKey = "financialConnections";
export const plaidConnectionsQueryKey = [
    financialConnectionsQueryKey,
    "plaidConnections",
];
export const stripeConnectionsQueryKey = [
    financialConnectionsQueryKey,
    "stripeConnections",
];

export const rampConnectionsQueryKey = [
    financialConnectionsQueryKey,
    "rampConnections",
];
export const gustoConnectionsQueryKey = [
    financialConnectionsQueryKey,
    "gustoConnections",
];
